
/**
 * Filter requested params from product object
 * @param {object} productObject
 * @param {Array} requestedParams
 * @returns {object}
 */
const filterParams = (productObject, requestedParams) => {
	const filteredObject = structuredClone(productObject);
	Object.keys(filteredObject).forEach((param) => {
		if (!requestedParams.includes(param)) {
			delete filteredObject[param];
		}
	});
	return filteredObject;
};

/**
 * Get requested params from products
 * @param {Array} products Array of products
 * @param {Array} requestedParams Params that need to be returned
 * @returns {object} Object with requested parameters arrays
 */
export default (products, requestedParams = []) => {
	const productObject = {
		product_id: [],
		product_qty: [],
		product_price: []
	};
	// Loop project and pick required data for AA
	products.forEach((product) => {
		productObject.product_id.push(product.sku);
		productObject.product_qty.push(product.quantity);
		productObject.product_price.push((product?.price?.street?.unformatted * product.quantity).toFixed(2)); // We need to calculate sum
	});
	return requestedParams.length === 0 ? productObject : filterParams(productObject, requestedParams);
};
